import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center'
  },
  button: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  quantityInputWrapper: {
    flexGrow: '1',
    display: 'inline-block',
    maxWidth: 48,
    height: 48,
    verticalAlign: 'middle'
  },
  quantityInput: {
    border: 'none',
    padding: '0',
    fontSize: '18px',
    width: 48,
    textAlign: 'center',
    outline: 'none',
    backgroundColor: 'transparent',
    height: 48,
    lineHeight: 48,
    color: 'inherit'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/QuantityInput/styles.js